import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AdminAuthProvider, useAdminAuth } from "@/context/AdminAuthContext";
import { PageLoader } from "@/admin/components";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Overview from "@/admin/pages/Overview";
import Astrologers from "@/admin/pages/Astrologers";
import Bookings from "@/admin/pages/Bookings";
import Revenue from "@/admin/pages/Revenue";
import Notifications from "@/admin/pages/Notifications";
import SystemHealth from "@/admin/pages/SystemHealth";
import ManualActions from "@/admin/pages/ManualActions";
import Payments from "@/admin/pages/Payments";
import Settings from "@/admin/pages/Settings";
import AstrologerForm from "@/admin/pages/AstrologerForm";
import Products from "@/admin/pages/Products";
import ProductOrders from "@/admin/pages/ProductOrders";

const RequireAdmin = () => {
  const { admin, loading } = useAdminAuth();
  if (loading) return <PageLoader />;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
};

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route element={<RequireAdmin />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/overview" replace />} />
            <Route path="overview" element={<Overview />} />
            <Route path="astrologers" element={<Astrologers />} />
            <Route path="astrologers/new" element={<AstrologerForm />} />
            <Route path="astrologers/:aid/edit" element={<AstrologerForm />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="revenue" element={<Revenue />} />
            <Route path="payments" element={<Payments />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="system-health" element={<SystemHealth />} />
            <Route path="manual-actions" element={<ManualActions />} />
            <Route path="settings" element={<Settings />} />
            <Route path="products" element={<Products />} />
            <Route path="product-orders" element={<ProductOrders />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/admin/overview" replace />} />
      </Routes>
    </AdminAuthProvider>
  );
}
